// utils/formatTime.js
export function formatTime(timeStr) {
    if (!timeStr) return "N/A";
    
    // Handle simple minute format like "20m"
    if (typeof timeStr === 'string' && timeStr.endsWith('m') && !isNaN(parseInt(timeStr))) {
      const minutes = parseInt(timeStr);
      return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }
  
    // Handle other time string formats
    const timeParts = {
      d: 0, // days
      h: 0, // hours
      m: 0, // minutes
      s: 0  // seconds
    };
  
    // Extract time parts from string
    const daysMatch = timeStr.match(/(\d+)d/);
    const hoursMatch = timeStr.match(/(\d+)h/);
    const minutesMatch = timeStr.match(/(\d+)m/);
    const secondsMatch = timeStr.match(/(\d+)s/);
  
    if (daysMatch) timeParts.d = parseInt(daysMatch[1], 10);
    if (hoursMatch) timeParts.h = parseInt(hoursMatch[1], 10);
    if (minutesMatch) timeParts.m = parseInt(minutesMatch[1], 10);
    if (secondsMatch) timeParts.s = parseInt(secondsMatch[1], 10);
  
    // Build human-readable string
    const parts = [];
    if (timeParts.d > 0) parts.push(`${timeParts.d} day${timeParts.d !== 1 ? 's' : ''}`);
    if (timeParts.h > 0) parts.push(`${timeParts.h} hour${timeParts.h !== 1 ? 's' : ''}`);
    if (timeParts.m > 0) parts.push(`${timeParts.m} minute${timeParts.m !== 1 ? 's' : ''}`);
    if (timeParts.s > 0) parts.push(`${timeParts.s} second${timeParts.s !== 1 ? 's' : ''}`);
  
    return parts.length > 0 ? parts.join(' ') : "N/A";
  }

  export function formatMillisecondsToTime(ms) {
  // Convert milliseconds to seconds
  let seconds = Math.floor(ms / 1000);
  
  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(seconds / 3600);
  seconds = seconds % 3600;
  const minutes = Math.floor(seconds / 60);
  seconds = seconds % 60;

  // Format with leading zeros
  const pad = (num) => num.toString().padStart(2, '0');
  
  // Only show hours if needed
  if (hours > 0) {
    return `${hours}:${pad(minutes)}:${pad(seconds)}`;
  }
  
  return `${minutes}:${pad(seconds)}`;
}